import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["children", "popoverIcon", "className"];
import * as React from 'react';
import clsx from 'clsx';
import Widget from '../Widget';
var styles = {
  "root": "Cell-root_1ruFk",
  "popoverIcon": "Cell-popoverIcon_3R4-Q"
};
function renderPopoverIcon(_ref) {
  var popoverIcon = _ref.popoverIcon;
  if (Array.isArray(popoverIcon)) {
    return popoverIcon.map(function (ppvrcn) {
      return /*#__PURE__*/React.cloneElement(ppvrcn, {
        className: styles.popoverIcon
      });
    });
  }
  if (popoverIcon && /*#__PURE__*/React.isValidElement(popoverIcon)) {
    return /*#__PURE__*/React.cloneElement(popoverIcon, {
      className: styles.popoverIcon
    });
  }
  return null;
}
function Cell(props) {
  var children = props.children,
    popoverIcon = props.popoverIcon,
    className = props.className,
    extraProps = _objectWithoutProperties(props, _excluded);
  var rootClasses = clsx(styles.root, className);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Widget, _extends({
      widgetFluidHeight: true,
      tagName: "span",
      flex: true,
      flexAlignItemsCenter: true,
      paddingLeft: "small",
      paddingRight: popoverIcon ? null : 'small',
      className: rootClasses
    }, extraProps), children, renderPopoverIcon(props))
  );
}
export default Cell;